import { CommonModule } from '@angular/common';
import { NgModule } from '@angular/core';
import { FormsModule } from '@angular/forms';
import { FontAwesomeModule } from '@fortawesome/angular-fontawesome';
import { ButtonModule } from 'primeng/button';
import { DropdownModule } from 'primeng/dropdown';

import { UplayButtonComponent } from '@usheru-hff/core/uplay-button';
import { HffCommonUiUsheruLogoModule } from '@usheru-hff/hff-common/ui-usheru-logo';
import {
  ShowtimeStreamingSubscribeComponent,
  FormSubscriptionComponent
} from '@usheru-hff/movie-detail/feature-subscribe';
import { FeatureStreamingCountrySelectorComponent } from '@usheru-hff/shared/feature-streaming-country-selector';
import { LoadingIndicatorComponent } from '@usheru-hff/shared/ui-loading-indicator';
import { SharedUiStreamingLogoFallbackModule } from '@usheru-hff/shared/ui-streaming-logo-fallback';
import { SharedUtilsModule } from '@usheru-hff/shared/utils';
import { SharedUtilsImageModule } from '@usheru-hff/shared/utils-image';

import { ShowtimeStreamingWatchAtHomeComponent } from './showtime-streaming-watch-at-home/showtime-streaming-watch-at-home.component';

import { MovieCardPlaceholderComponent } from '@usheru-hff/ui/movie-card-placeholder';
import { SkeletonModule } from 'primeng/skeleton';
@NgModule({
  imports: [
    CommonModule,

    DropdownModule,
    ButtonModule,
    FormsModule,
    UplayButtonComponent,
    LoadingIndicatorComponent,
    SharedUtilsModule,
    SharedUiStreamingLogoFallbackModule,
    HffCommonUiUsheruLogoModule,
    FontAwesomeModule,
    SharedUtilsImageModule,
    ShowtimeStreamingSubscribeComponent,
    FormSubscriptionComponent,
    FeatureStreamingCountrySelectorComponent,
    MovieCardPlaceholderComponent,
    SkeletonModule
  ],
  declarations: [ShowtimeStreamingWatchAtHomeComponent],
  exports: [ShowtimeStreamingWatchAtHomeComponent]
})
export class MovieDetailFeatureStreamingModule {}
